import React from 'react';
import styled, { createGlobalStyle } from 'styled-components/macro';
// constants
import { getSocialIconObject } from './Constants';
import { VIDEO_WITH_NESTED_IMAGE } from 'const/keys';
// components
import Slider from './Slider/Slider';
import { PrimaryButton } from 'components/PrimaryButton';
import { VideoPlayer } from 'components/videoPlayer';
import ReactionAndComment from '../reactionAndComments';
import { useCreateStatsLinksMutation } from 'queries/stats/createStatsLinksMutation';
import { TranscriptionData } from 'queries/video/types';
interface ElementProps {
  maxWidth?: string;
  margin?: string;
  height?: string;
  width?: string;
  src?: string;
  content?: any;
  color?: string;
  display?: string;
  float?: string;
  isVisible?: boolean;
  backgroundColor?: string;
  backgroundImage?: string;
  padding?: string;
  gridTemplateColumns?: string;
  gridGap?: string;
  justifyItems?: string;
  fontFamily?: string;
  fontSize?: string;
  fontWeight?: string;
  textAlign?: string;
  flexDirection?: string;
  overflowX?: string;
  name?: string;
  minWidth?: string;
  id?: string;
  backgroundSize?: string;
  backgroundPosition?: string;
  flexWrap?: string;
  justifyContent?: string;
  alignItems?: string;
  isFullScreen?: boolean;
}

type ObjectProperties = {
  [key: string]: any;
};

const GlobalStyle = createGlobalStyle<{ url: string; fontFamily: string }>`
  @font-face {
    font-family: '${({ fontFamily }) => fontFamily}';
    src: url('${({ url }) => url}') format('truetype');
  }
`;

const shapeToClassMapping: ObjectProperties = {
  rounded: 'roundedShape',
  circular: 'circularShape',
  sharp: 'sharpShape',
};
const positionToMarginMapping: ObjectProperties = {
  left: '0px auto 0px 10px',
  center: '0px auto 0px auto',
  right: '0px 10px 0px auto',
};

type MainContainerProps = {
  backgroundColor?: string;
  backgroundImageUrl?: string;
  pageBackgroundPosition?: string;
  pageBackgroundSize?: string;
};

const Wrapper = styled.div<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }) =>
    backgroundColor || 'transparent'};
  min-height: 100vh;
`;

const Container = styled.div<MainContainerProps>`
  display: flex;
  flex: 0 0 100%;
  width: 100%;
  flex-wrap: wrap;
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : 'transparent'};
  background-image: ${props =>
    props.backgroundImageUrl ? 'url("' + props.backgroundImageUrl + '")' : ''};
  background-size: ${props =>
    props.pageBackgroundSize ? props.pageBackgroundSize : 'cover'};
  background-position: ${props =>
    props.pageBackgroundPosition ? props.pageBackgroundPosition : 'left top'};
  .sharpShape {
    border-radius: 0px;
  }

  .circularShape {
    border-radius: 20px;
  }

  .roundedShape {
    border-radius: 5px;
  }
  .zoomin {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
  }

  @-webkit-keyframes zoom {
    from {
      -webkit-transform: scale(0);
    }

    to {
      -webkit-transform: scale(1);
    }
  }

  @keyframes zoom {
    from {
      transform: scale(0);
    }

    to {
      transform: scale(1);
    }
  }
`;

const ImageModal = styled.div`
  display: none;
  position: fixed;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 100;
`;

const ImageModalContent = styled.img`
  margin: auto;
  display: block;
  width: fit-content;
  max-width: 700px;
`;

const ImageModalClose = styled.span`
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.6s;
  cursor: pointer;
`;

const Row = styled.div<ElementProps>`
  display: ${props => (props.display ? props.display : 'block')};
  width: ${props => (props.width ? props.width : '100%')};
  padding: ${props => (props.padding ? props.padding : '15px 5px 15px 5px')};
  max-width: 100%;
  box-sizing: border-box;
  border-radius: 0px;
  height: ${props => (props.height ? props.height : 'fit-content')};
  float: ${props => (props.float ? props.float : '')};
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : 'transparent'};
  background-image: ${props =>
    props.backgroundImage ? 'url("' + props.backgroundImage + '")' : ''};
  visibility: ${props => (props.isVisible == false ? 'hidden' : 'visible')};
  grid-template-columns: ${props =>
    props.gridTemplateColumns ? props.gridTemplateColumns : ''};
  grid-gap: ${props => (props.gridGap ? props.gridGap : '')};
  justify-items: ${props => (props.justifyItems ? props.justifyItems : '')};
  text-align: ${props => (props.textAlign ? props.textAlign : '')};
  margin: ${props => (props.margin ? props.margin : '')};
  overflow-x: ${props => (props.overflowX ? props.overflowX : '')};
  background-repeat: no-repeat;
  background-size: ${props =>
    props.backgroundSize ? props.backgroundSize : 'cover'};
  background-position: ${props =>
    props.backgroundPosition ? props.backgroundPosition : 'left top'};
  word-wrap: break-word;
  align-items: ${props => (props.alignItems ? props.alignItems : '')};
  flex-wrap: wrap;

  @media (max-width: 812px) {
    width: 100%;
  }
`;

const ElementContainer = styled.div<ElementProps>`
  width: ${props => (props.width ? props.width : 'auto')};
  max-width: 100%;
  height: ${props => (props.height ? props.height : 'auto')};
  float: ${props => (props.float ? props.float : '')};
  margin: ${props => (props.margin ? props.margin : 'auto')};
  padding: ${props => (props.padding ? props.padding : '5px')};
  box-sizing: border-box;
  visibility: ${props => (props.isVisible == false ? 'hidden' : 'visible')};
  text-align: ${props => (props.textAlign ? props.textAlign : '')};
  display: ${props => (props.display ? props.display : '')};
  flex-direction: ${props => (props.flexDirection ? props.flexDirection : '')};
  flex-wrap: ${props => (props.flexWrap ? props.flexWrap : '')};
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : ''};
  video {
    height: '100%';
    max-height: fit-content;
  }
  figure {
    width: '800px';
  }

  figure div.fullscreen {
    height: auto;
  }
  @media (max-width: 812px) {
    margin: auto;
  }
`;

const LogoElement = styled.img<ElementProps>`
  width: 100%;
  min-width: ${props => (props.minWidth ? props.minWidth : '')};
  max-width: ${props => (props.maxWidth ? props.maxWidth : 'auto')};
  height: ${props => (props.height ? props.height : 'auto')};
  margin: ${props => (props.margin ? props.margin : '')};
  display: ${props => (props.display ? props.display : 'block')};
  visibility: ${props => (props.isVisible == false ? 'hidden' : 'visible')};
  max-height: 100%;

  @media (max-width: 812px) {
    margin: auto;
  }
`;

const TextElement = styled.div<ElementProps>`
  max-width: ${props => (props.width ? props.width : 'auto')} !important;
  min-height: ${props => (props.height ? props.height : 'auto')} !important;
  margin: ${props => (props.margin ? props.margin : '')} !important;
  color: ${props => (props.color ? props.color : 'white')} !important;
  display: ${props => (props.display ? props.display : 'block')} !important;
  float: ${props => (props.float ? props.float : '')} !important;
  visibility: ${props =>
    props.isVisible == false ? 'hidden' : 'visible'} !important;
  font-family: ${props =>
    props.fontFamily ? props.fontFamily : 'inherit'} !important;
  font-size: ${props =>
    props.fontSize ? props.fontSize : 'inherit'} !important;
  p {
    color: ${props => (props.color ? props.color : 'white')} !important;
    display: ${props => (props.display ? props.display : 'block')} !important;
    float: ${props => (props.float ? props.float : '')} !important;
    visibility: ${props =>
      props.isVisible == false ? 'hidden' : 'visible'} !important;
    font-family: ${props =>
      props.fontFamily ? props.fontFamily : 'inherit'} !important;
    font-size: ${props =>
      props.fontSize ? props.fontSize : 'inherit'} !important;
    margin: 0 !important;
  }
  a {
    text-decoration: none !important;
  }
  font-weight: ${props =>
    props.fontWeight ? props.fontWeight : 'inherit !important'};
`;

const ImageElement = styled.img<ElementProps>`
  width: ${props => (props.width ? props.width : 'auto')};
  min-width: ${props => (props.minWidth ? props.minWidth : '')};
  max-width: ${props => (props.maxWidth ? props.maxWidth : 'auto')};
  height: ${props => (props.height ? props.height : 'auto')};
  margin: ${props => (props.margin ? props.margin : '')};
  display: ${props => (props.display ? props.display : 'block')};
  visibility: ${props => (props.isVisible == false ? 'hidden' : 'visible')};
  cursor: ${props => (props.maxWidth === '320px' ? 'pointer' : '')};
`;

const VideoCtaWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  width: 620px;
  margin-right: 24px;

  @media screen and (max-width: 1024px) {
    margin: 0;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    margin: 0;
  }
`;

const ReactionContainer = styled.div`
  position: relative;
  width: 100%;
  bottom: 17px;
`;

const AdditionalTextContainer = styled.div<{ textColor: string }>`
  display: block;
  position: relative;
  width: 100%;
  margin-bottom: 20px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin: 0 24px;
  color: ${({ textColor }) => textColor};
`;

const InnerContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

type Props = {
  pageData?: any;
  ctaSetData?: any;
  renderAutomotiveItems?: any;
  orderDetails?: any;
  interactiveCTAs?: any;
  design?: any;
  viewerStatisticId?: any;
  renderMediaQuery?: any;
  inventoryItem?: any;
  renderAdditionalText?: any;
  renderPlayerReactions?: any;
  reactionsAndCommentsEnabled?: any;
  videoRef?: any;
  shortUrl: string;
  transcript?: TranscriptionData;
};

export const CustomLandingPage = (props: Props) => {
  const {
    pageData,
    ctaSetData,
    renderAutomotiveItems,
    renderAdditionalText,
    renderPlayerReactions,
    reactionsAndCommentsEnabled,
    orderDetails,
    interactiveCTAs,
    design,
    viewerStatisticId,
    renderMediaQuery,
    inventoryItem,
    videoRef,
    shortUrl,
    transcript,
  } = props;

  const { mutate: createStatsLinksMutation } = useCreateStatsLinksMutation();

  const { selectedLayoutData, pageDetails } = pageData;
  const { firstName, lastName, email, phone, phone2, department } =
    orderDetails?.advisor;
  const { selectedStyleProperties } = pageDetails;
  const templateVariablesObject: any = {
    '{{firstname}}': firstName || '',
    '{{lastname}}': lastName || '',
    '{{email}}': email || '',
    '{{phone1}}': phone ? phone.trim() : '',
    '{{phone2}}': phone2 ? phone2.trim() : '',
    '{{department}}': department || '',
  };

  const openImage = (event: any) => {
    const modal = document.getElementById('myModal') as HTMLDivElement;
    if (!modal) {
      return;
    }
    // Get the image and insert it inside the modal - use its "alt" text as a caption
    const img: HTMLImageElement = event.target as HTMLImageElement;
    const modalImg: HTMLImageElement = document.getElementById(
      'img01'
    ) as HTMLImageElement;
    if (!modalImg) {
      return;
    }

    modalImg.classList.add('zoomin');

    modalImg.src = img.src;
    modal.style.display = 'block';
    const span = document.getElementById('imageModalClose') as HTMLSpanElement;
    if (!span) {
      return;
    }

    span.onclick = function () {
      modalImg.classList.remove('zoomin');
      modalImg.src = '';
      modal.style.display = 'none';
    };

    return false;
  };

  const renderImageAsSibling = (
    id: string,
    key: string = '',
    sectionDetails: any = null
  ) => {
    if (!sectionDetails) {
      sectionDetails = selectedLayoutData[key];
    }
    if (!sectionDetails) {
      return <></>;
    }

    const imageArray = sectionDetails.images || [];
    const gridSize = sectionDetails.gridSize || 4;
    const arr = Array(gridSize).fill('auto');
    return (
      <Row>
        <Row
          display={'grid'}
          gridGap={'12px'}
          justifyItems={'center'}
          gridTemplateColumns={arr.join(' ')}
          width={'fit-content'}
          overflowX={'auto'}
          margin={'auto'}
          name={'imageSectionContainer'}
          id={id}
        >
          {imageArray.map((item: any, index: number) => {
            if (item && item.url) {
              const isSvg = /.*\.(svg)/i.test(item.url);
              return (
                <ImageElement
                  src={item.url}
                  width={'auto'}
                  height={'auto'}
                  maxWidth={'320px'}
                  key={item.url + index}
                  alt={item.altText || ''}
                  minWidth={isSvg === true ? '135px' : ''}
                  isVisible={sectionDetails.isVisible}
                  onClick={(e: React.MouseEvent<HTMLImageElement>) => {
                    openImage(e);
                  }}
                />
              );
            }
            return null;
          })}
        </Row>
      </Row>
    );
  };

  const renderCTA = (
    key: string = '',
    id: string,
    sectionDetails: any = null
  ) => {
    if (!sectionDetails) {
      sectionDetails = selectedLayoutData[key];
    }
    if (!sectionDetails) {
      return <></>;
    }

    const elementContainerPosition = sectionDetails.sectionPosition || 'center';
    let ctaSetArray = ctaSetData?.links || [];

    if (
      sectionDetails.sectionType == '8' ||
      sectionDetails.isOverrideCTA === true
    ) {
      ctaSetArray = sectionDetails.links;
    }

    const elementProperties = sectionDetails.elementProperties || {};
    const shape = elementProperties.elementShape || 'rounded';
    const shapeClassName = shapeToClassMapping[shape] || '';
    const isVertical = sectionDetails.isVertical || false;

    const textColor =
      elementProperties.elementTextColor ||
      selectedStyleProperties.backgroundColor ||
      '#FFFFFF';
    const fontFamily =
      elementProperties.fontFamily || selectedStyleProperties.fontFamily;
    const fontWeight =
      elementProperties.fontStyle || selectedStyleProperties.fontWeight;
    const fontUrl = elementProperties?.fontUrl;
    const backgroundColor =
      elementProperties.elementBackgroundColor ||
      selectedStyleProperties.textColor;

    const onCtaClick = (ctaItem: any) => {
      // save click to stats links
      const statsLink = {
        viewerStatisticId: viewerStatisticId || -1,
        linksetId: ctaItem.ctaSetId || -1,
        designId: -2,
        linkId: ctaItem.id || -1,
      };
      createStatsLinksMutation({ data: statsLink, shortUrl });

      window.open(ctaItem.linkValue, '_blank');
      if (ctaItem.type === 'video') {
        const currentVideo = videoRef.current;
        if (currentVideo) {
          currentVideo.pause();
        }
      }
    };

    return (
      <ElementContainer
        display={isVertical == true ? 'flex' : ''}
        flexDirection={isVertical == true ? 'column' : ''}
        id={id}
        width={'fit-content'}
        margin={positionToMarginMapping[elementContainerPosition]}
        className={'sectionListItem'}
        isVisible={sectionDetails.isVisible}
      >
        {fontUrl && fontFamily && (
          <GlobalStyle
            key={`style-${id}`}
            url={fontUrl}
            fontFamily={fontFamily}
          />
        )}
        {ctaSetArray &&
          ctaSetArray.map((ctaItem: any, index: number) => {
            return (
              <PrimaryButton
                key={index.toString() + new Date().getTime()}
                margin={'10px'}
                className={shapeClassName}
                text={ctaItem.linkText}
                borderRadius={5}
                height={'40px'}
                minWidth={'142px'}
                hoverBackgroundColor={
                  elementProperties.elementHoverBackgroundColor || ''
                }
                hoverTextColor={elementProperties.elementHoverTextColor || ''}
                textColor={textColor}
                fontSize={elementProperties.fontSize}
                fontFamily={fontFamily}
                fontWeight={fontWeight}
                backgroundColor={backgroundColor}
                center={true}
                onClick={() => onCtaClick(ctaItem)}
                isVisible={sectionDetails.isVisible}
              />
            );
          })}
      </ElementContainer>
    );
  };

  const renderHeaderSection = (sectionKey: string, id: string) => {
    const sectionDetails = selectedLayoutData[sectionKey];
    let childSectionsArray = sectionDetails.childSections || [];
    if (!childSectionsArray.length) {
      return <></>;
    }

    const visibleChildrenArray: any[] = [];
    for (let i = 0; i < childSectionsArray.length; i++) {
      if (childSectionsArray[i].isVisible == true) {
        visibleChildrenArray.push(childSectionsArray[i]);
      }
    }
    let rowWidth = 100 / (visibleChildrenArray.length || 1) + '%';
    return (
      <>
        {childSectionsArray.map((item: any, index: number) => {
          if (item.isVisible == false) {
            return <></>;
          }
          let childId = id + '-' + item.sectionType + '-' + index.toString();
          let Element = <></>;
          switch (item.sectionType) {
            case 4: {
              Element = renderSocialLinks(sectionKey, childId, index);
              break;
            }
            case 5: {
              Element = renderTextSection(sectionKey, id, true, index);
              break;
            }
            case 9: {
              Element = renderLogoSection(sectionKey, id, true, index);
              break;
            }
            default: {
              Element = <></>;
              break;
            }
          }
          return (
            <Row
              display={item.isVisible == false ? 'none' : ''}
              key={'HEADER-' + index}
              width={rowWidth}
              float={'left'}
            >
              {Element}
            </Row>
          );
        })}
      </>
    );
  };

  const renderSocialLinks = (
    key: string,
    id: string,
    index: number = -1,
    isHeaderCase: boolean = false,
    childId: any = null
  ) => {
    let sectionDetails;
    if (index !== null && index !== undefined && index >= 0) {
      sectionDetails = selectedLayoutData[key].childSections[index];
    } else {
      sectionDetails = selectedLayoutData[key];
    }

    if (!sectionDetails) {
      return <></>;
    }

    const elementContainerPosition = sectionDetails.sectionPosition || 'center';
    let socialLinks = sectionDetails.socialLinks || {};
    const shape = sectionDetails.elementShape;
    let keyArray = Object.keys(socialLinks);
    const socialIconObject: { [key: string]: any } = getSocialIconObject(
      shapeToClassMapping[shape] || ''
    );

    const anchorStyle = {
      textDecoration: 'none',
      display: 'inline-flex',
    };
    return (
      <ElementContainer
        id={isHeaderCase == true ? childId : id}
        width={'fit-content'}
        margin={positionToMarginMapping[elementContainerPosition]}
        className={'sectionListItem'}
        isVisible={sectionDetails.isVisible}
        display={'flex'}
        flexWrap={'wrap'}
        justifyContent={'center'}
      >
        {keyArray.map(keyName => {
          if (socialIconObject[keyName]) {
            let element = socialIconObject[keyName];
            return (
              <a
                style={anchorStyle}
                key={keyName + new Date().getTime()}
                href={socialLinks[keyName]}
                target={'_blank'}
                rel='noreferrer'
              >
                {element}
              </a>
            );
          }
          return null;
        })}
      </ElementContainer>
    );
  };

  const renderTextSection = (
    sectionKey: string,
    id: string,
    isHeaderCase: boolean = false,
    childIndex: number = -1
  ) => {
    let sectionDetails = selectedLayoutData[sectionKey];
    let childId = id;
    if (isHeaderCase && childIndex >= 0) {
      sectionDetails = selectedLayoutData[sectionKey].childSections[childIndex];
      childId =
        id + '-' + sectionDetails.sectionType + '-' + childIndex.toString();
    }

    const textColor =
      sectionDetails.textColor ||
      selectedStyleProperties.textColor ||
      '#FFFFFF';
    const fontFamily =
      sectionDetails.textFont || selectedStyleProperties.fontFamily;
    const fontWeight =
      sectionDetails.textWeight || selectedStyleProperties.fontWeight;
    const fontUrl = sectionDetails?.fontUrl;

    let textContent = replaceTemplateVariables(
      decodeURIComponent(sectionDetails.textContent || '')
    );

    return (
      <ElementContainer
        className={'sectionListItem'}
        id={isHeaderCase == true ? childId : id}
        width={'fit-content'}
        margin={
          positionToMarginMapping[sectionDetails.sectionPosition || 'center']
        }
      >
        {fontUrl && fontFamily && (
          <GlobalStyle
            key={`style-${isHeaderCase == true ? childId : id}`}
            url={fontUrl}
            fontFamily={fontFamily}
          />
        )}
        <TextElement
          isVisible={sectionDetails.isVisible}
          width={sectionDetails.textWidth || 'auto'}
          height={sectionDetails.textHeight || 'auto'}
          fontFamily={fontFamily}
          fontSize={sectionDetails.textSize || '16px'}
          fontWeight={fontWeight}
          color={textColor}
          dangerouslySetInnerHTML={{
            __html: textContent,
          }}
        />
      </ElementContainer>
    );
  };

  const replaceTemplateVariables = (textContent: string) => {
    Object.keys(templateVariablesObject).forEach((templateString: string) => {
      textContent = textContent.replace(
        templateString,
        templateVariablesObject[templateString].toString()
      );
    });

    return textContent;
  };

  const renderLogoSection = (
    sectionKey: string,
    id: string,
    isHeaderCase: boolean = false,
    childIndex: number = -1
  ) => {
    let sectionDetails = selectedLayoutData[sectionKey];
    let childId = id;
    if (isHeaderCase && childIndex >= 0) {
      sectionDetails = selectedLayoutData[sectionKey].childSections[childIndex];
      childId =
        id + '-' + sectionDetails.sectionType + '-' + childIndex.toString();
    }

    return (
      <LogoElement
        margin={
          positionToMarginMapping[sectionDetails.sectionPosition || 'center']
        }
        id={isHeaderCase == true ? childId : id}
        name={'logoImage'}
        src={sectionDetails.logoUrl}
        maxWidth={sectionDetails.logoWidth || 'auto'}
        height={sectionDetails.logoHeight || 'auto'}
        display={sectionDetails.logoDisplay}
        className={'sectionListItem'}
        alt={sectionDetails.altText}
        isVisible={sectionDetails.isVisible}
      />
    );
  };

  const renderCovideoSection = (
    sectionKey: string,
    id: string,
    childId: any = null
  ) => {
    const sectionDetails = selectedLayoutData[sectionKey];
    const VideoPlayerElement = renderVideoPlayerSection(sectionKey, id);
    let siblingSection = null;
    if (
      sectionDetails &&
      sectionDetails.childSections &&
      sectionDetails.childSections[0] &&
      sectionDetails.childSections[0].isVisible == true
    ) {
      siblingSection = sectionDetails.childSections[0];
      childId = id + '-' + siblingSection.sectionType + '-0';
      siblingSection.isVertical = true;
      let SiblingElement =
        sectionDetails.name === VIDEO_WITH_NESTED_IMAGE
          ? renderImageAsSibling(childId, '', siblingSection)
          : renderCTA(childId, '', siblingSection);
      return (
        <Row display={'flex'} alignItems={'center'} padding={'0px'}>
          {sectionDetails.isVisible && (
            <Row
              width={siblingSection.isVisible ? '75%' : '100%'}
              padding={'0px'}
              float={'left'}
            >
              {VideoPlayerElement}
            </Row>
          )}
          {siblingSection.isVisible && (
            <Row
              width={sectionDetails.isVisible ? '25%' : '100%'}
              padding={'0px'}
              float={'left'}
            >
              {SiblingElement}
            </Row>
          )}
        </Row>
      );
    } else {
      return <>{VideoPlayerElement}</>;
    }
  };

  const renderVideoPlayerSection = (sectionKey: string, id: string) => {
    const sectionDetails = selectedLayoutData[sectionKey];
    const isOverrideVideoSettings =
      sectionDetails.overrideVideoSettings || false;
    const videoPlayerProperties = sectionDetails.videoPlayerProperties || {};
    let playerBackgroundColor = design?.playerBackgroundColor;
    let playerIconsColor = design?.playerIconsAndTextColor;
    let playButtonPosition = design?.playButtonPosition;
    if (isOverrideVideoSettings == true) {
      playerBackgroundColor =
        videoPlayerProperties.playerBackgroundColor || '#585B5D';
      playButtonPosition =
        videoPlayerProperties.playerButtonPosition || 'center';
      playerIconsColor = videoPlayerProperties.playerIconsColor || '#ffffff';
    }
    const designOverride = {
      playerBackgroundColor: playerBackgroundColor,
      playButtonPosition: playButtonPosition,
      playerIconsAndTextColor: playerIconsColor,
    };

    return (
      <ElementContainer
        isVisible={sectionDetails.isVisible}
        id={id}
        className={'sectionListItem'}
        margin={positionToMarginMapping[sectionDetails.sectionPosition]}
      >
        <InnerContainer>
          {renderMediaQuery(designOverride)}
          {!inventoryItem && (
            <VideoCtaWrapper>
              <VideoPlayer
                margin='auto'
                width='620px'
                height='320px'
                preventWideSize={true}
                videoSource={orderDetails?.video?.videoSource}
                thumbnail={orderDetails?.video?.thumbnail}
                videoRef={videoRef}
                interactiveCTAs={interactiveCTAs}
                videoId={orderDetails?.videoId}
                userId={viewerStatisticId}
                isAutomotive={true}
                previewAnnotation={orderDetails.annotations}
                videoChapters={orderDetails?.video?.chapters || []}
                playButtonPosition={playButtonPosition}
                playerBackgroundColor={playerBackgroundColor}
                playerIconsColor={playerIconsColor}
                hidePoweredBy={orderDetails.hidePoweredBy}
                transcript={transcript}
              />
              <ReactionContainer>{renderPlayerReactions()}</ReactionContainer>
              {reactionsAndCommentsEnabled && (
                <ReactionAndComment
                  videoRef={videoRef}
                  playbackData={orderDetails}
                />
              )}
            </VideoCtaWrapper>
          )}
          {renderAutomotiveItems()}
        </InnerContainer>
      </ElementContainer>
    );
  };

  const renderImageSection = (sectionKey: string, id: string) => {
    const sectionDetails = selectedLayoutData[sectionKey];
    if (sectionDetails.isVisible == false) {
      return <></>;
    }

    const imageArray = sectionDetails.images || [];
    const gridSize = sectionDetails.gridSize || 4;
    const arr = Array(gridSize).fill('auto');
    let imgMaxWidth = 320;
    if (window.innerWidth && window.innerWidth < 320) {
      imgMaxWidth = window.innerWidth - 30 || 0;
    }
    return (
      <Row>
        <Row
          display={'grid'}
          gridGap={'12px'}
          justifyItems={'center'}
          gridTemplateColumns={arr.join(' ')}
          width={'fit-content'}
          overflowX={'auto'}
          margin={'auto'}
          name={'imageSectionContainer'}
          id={id}
        >
          {imageArray.map((item: any, index: number) => {
            if (item && item.url) {
              let isSvg = false;
              isSvg = /.*\.(svg)/i.test(item.url);
              return (
                <ImageElement
                  key={'img-' + index}
                  src={item.url}
                  width={'auto'}
                  height={'auto'}
                  maxWidth={`${imgMaxWidth}px`}
                  minWidth={isSvg === true ? '135px' : ''}
                  isVisible={sectionDetails.isVisible}
                  onClick={(e: React.MouseEvent<HTMLImageElement>) => {
                    if (imgMaxWidth !== 320) {
                      return;
                    }
                    openImage(e);
                  }}
                />
              );
            }
            return <></>;
          })}
        </Row>
      </Row>
    );
  };

  const renderEmbedVideoSection = (sectionKey: string, id: string) => {
    const sectionDetails = selectedLayoutData[sectionKey];
    if (sectionDetails.isVisible == false) {
      return <></>;
    }
    const embedVideoElementArray = selectedLayoutData[sectionKey].videos || [];
    const filteredArray = embedVideoElementArray.filter(
      (video: string) => video && video.trim() !== ''
    );
    const ref = React.createRef<HTMLDivElement>();
    return (
      <Row padding={'0px'} height={'500px'}>
        <ElementContainer
          id={id}
          ref={ref}
          width={'fit-content'}
          margin={positionToMarginMapping[sectionDetails.sectionPosition]}
          className={'sectionListItem'}
          isVisible={selectedLayoutData[sectionKey].isVisible}
        >
          {filteredArray.length > 0 && (
            <Slider
              slides={filteredArray}
              pageDetails={pageDetails}
              selectedLayoutData={selectedLayoutData}
              parentElementRef={ref}
            />
          )}
        </ElementContainer>
      </Row>
    );
  };

  const renderSections = (sectionKey: string) => {
    const sectionDetails = selectedLayoutData[sectionKey];
    const backgroundColor = sectionDetails.sectionBackgroundColor;
    if (sectionDetails.sectionType != 2 && sectionDetails.isVisible == false) {
      return <></>;
    }
    const sectionType = sectionDetails.sectionType;
    const id =
      sectionKey + '-' + sectionType + '-' + (parseInt(sectionKey) - 1);
    let SectionElement;
    switch (sectionType) {
      case 1: {
        SectionElement = renderHeaderSection(sectionKey, id);
        break;
      }
      case 2: {
        SectionElement = renderCovideoSection(sectionKey, id);
        break;
      }
      case 3: {
        SectionElement = renderCTA(sectionKey, id);
        break;
      }
      case 4: {
        SectionElement = renderSocialLinks(sectionKey, id);
        break;
      }
      case 5: {
        SectionElement = renderTextSection(sectionKey, id);
        break;
      }
      case 6: {
        SectionElement = renderImageSection(sectionKey, id);
        break;
      }
      case 7: {
        SectionElement = renderEmbedVideoSection(sectionKey, id);
        break;
      }
      case 8: {
        SectionElement = renderCTA(sectionKey, id);
        break;
      }
      case 9: {
        SectionElement = renderLogoSection(sectionKey, id);
        break;
      }
    }

    return (
      <Row
        backgroundImage={
          selectedLayoutData[sectionKey].sectionBackgroundImageUrl
        }
        backgroundPosition={
          selectedLayoutData[sectionKey].sectionBackgroundPosition
        }
        backgroundSize={selectedLayoutData[sectionKey].sectionBackgroundSize}
        backgroundColor={backgroundColor}
        isVisible={selectedLayoutData[sectionKey].isVisible}
        textAlign={
          sectionType == 8 || sectionType == 3
            ? sectionDetails.sectionPosition
            : ''
        }
        className={
          sectionType == 4 || sectionType == 1 ? 'sectionListItem' : ''
        }
        id={sectionType == 1 ? id : ''}
        key={`row-${id}`}
      >
        {SectionElement}
      </Row>
    );
  };

  return (
    <Wrapper backgroundColor={pageDetails.backgroundColor}>
      <Container
        backgroundColor={pageDetails.backgroundColor}
        backgroundImageUrl={pageDetails.backgroundImageUrl}
        pageBackgroundPosition={pageDetails.pageBackgroundPosition}
        pageBackgroundSize={pageDetails.pageBackgroundPosition}
      >
        <ImageModal id={'myModal'}>
          <ImageModalClose id={'imageModalClose'}>&times;</ImageModalClose>
          <ImageModalContent id={'img01'}></ImageModalContent>
        </ImageModal>
        {selectedLayoutData && Object.keys(selectedLayoutData).length > 0 ? (
          <>
            {Object.keys(selectedLayoutData).map(key => {
              return renderSections(key);
            })}
            <AdditionalTextContainer
              textColor={
                orderDetails.additionalTextColorForSales ||
                orderDetails.additionalTextColorForService
              }
            >
              {renderAdditionalText()}
            </AdditionalTextContainer>
          </>
        ) : (
          <></>
        )}
      </Container>
    </Wrapper>
  );
};
